import React from 'react';
import ReactDOM from 'react-dom';
import { FiAlertTriangle } from 'react-icons/fi';
import './ConfirmationModal.css';

/**
 * The app's ordinary confirmation (the middle of the three tiers in CLAUDE.md:
 * native confirm for the reversible, this for an ordinary delete,
 * DangerConfirmModal where data cannot come back).
 *
 * `tone` says what kind of question it is, because the ICON is a claim:
 *   'danger'   something is removed or discarded — red warning, red button
 *   'neutral'  an ordinary question — no icon (the default)
 *   'success'  announcing something that already worked — the green tick
 * It used to draw the animated success tick on EVERY dialog, so "Delete John
 * Smith? This can't be undone." opened with a tick and a blue Delete.
 *
 * Its own `cm-` classes, not the bare `.modal-content` / `.save-button` /
 * `.cancel-button` other stylesheets also define: those overrode this one, so
 * it rendered at the wrong size, and once the scorecard chunk had loaded its
 * Cancel turned transparent. Portalled outside `.App`, so it names its font.
 */
const ConfirmationModal = ({
  isOpen,
  title,
  message,
  confirmText = 'Yes',
  cancelText = 'No',
  onConfirm,
  onCancel,
  tone = 'neutral',
  children,
}) => {
  if (!isOpen) return null;

  return ReactDOM.createPortal(
    <div className="cm-overlay" role="presentation">
      <div className={`cm-card cm-card--${tone}`} role="alertdialog" aria-modal="true"
           aria-labelledby="cm-title" aria-describedby="cm-message">
        {tone === 'danger' && (
          <div className="cm-icon cm-icon--danger" aria-hidden="true">
            <FiAlertTriangle size={26} />
          </div>
        )}
        {tone === 'success' && (
          <div className="cm-icon" aria-hidden="true">
            <div className="checkmark-circle"><div className="checkmark draw" /></div>
          </div>
        )}
        <h2 id="cm-title" className="cm-title">{title}</h2>
        {message && <p id="cm-message" className="cm-message">{message}</p>}
        {children}
        <div className="cm-actions">
          <button type="button" onClick={onConfirm}
                  className={`cm-btn cm-btn--confirm${tone === 'danger' ? ' cm-btn--danger' : ''}`}>
            {confirmText}
          </button>
          <button type="button" onClick={onCancel} className="cm-btn cm-btn--cancel">{cancelText}</button>
        </div>
      </div>
    </div>,
    document.body,
  );
};

export default ConfirmationModal;
